module.exports = __webpack_public_path__ + "img/tick-failed.9e5603ea.svg";